import React, {useEffect, useState} from "react";
import Sidebar from "../SIDEBAR-COMPONENTS/Sidebar";
import ViewWrapper from "../ViewWrapper";
import Navbar from "../../layouts/Navbar/Navbar";
import {
    fetchAccountingPaymentTypes,
    fetchAccountingSettings, fetchAdvancedTypes,
    fetchAdvancedTypesBuys, fetchAdvancedTypesSales, fetchBuysGeneralSettings,
    fetchCategory,
    fetchClientsSettings,
    fetchCompanyDetails,
    fetchCompanyInstallations, fetchCompanyStatus, fetchDashboardData,
    fetchEmailSmtp, fetchPayrollSettings,
    fetchPrimerMyDataData, fetchSalesGeneralSettings,
    fetchSuppliersSettings, fetchSyncInvoicesProviderLog, fetchUserSettings,
} from "../../../_apis/api";
import OfflineAlert from "../../common/OnlineOffline/offlineAlert";
import {useDispatch, useSelector} from "react-redux";
import {checkPermission, getCurrentUser, isEmpty} from "../../../_helpers/commonFunctions";
import {getURLParams} from "../../../_helpers/helperFunctions";
import EmronRegisterFile from "../data-panel/Cloud/EmronRegisterFile";
import {useTranslation} from "../../../hooks/useTranslation";

const MainWrapper = () => {
    const {setLocale} = useTranslation();
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const [isEmronCloudTab, setIsEmronCloudTab] = useState(false);
    const [emronCloudTabDataSSKey, setEmronCloudTabDataSSKey] = useState("");
    const [emronCloudTabData, setEmronCloudTabData] = useState("");

    useEffect(() => {
        if (localStorage.getItem("token")) {
            const permissionsData = JSON.parse(localStorage.getItem("user"))?.permissions;
            const isEpay = permissionsData?.some((el) => el.permissionName === "custom-epay" || el.permissionName === "custom-peiraios" || el.permissionName === "custom-daras");
            const isCardlink = permissionsData?.some((el) => el.permissionName === "custom-cardlink");
            const isEmployee = permissionsData?.some((el) => el.permissionName === "custom-employee");
            const isPrimerConstructor = permissionsData?.some((el) => el.permissionName === "custom-primerConstructor");

            if (!isEmpty(getURLParams().get("emronCloudDataTS"))) {
                const ts = getURLParams().get("emronCloudDataTS");
                const emronCloudData = sessionStorage.getItem(`emronCloudData-${ts}`);
                if (emronCloudData) {
                    setEmronCloudTabData(JSON.parse(emronCloudData));
                    setEmronCloudTabDataSSKey(`emronCloudData-${ts}`);
                    setIsEmronCloudTab(true);
                    window.history.pushState({}, "", window.location.origin);
                }
            } else if (!isEpay && !isCardlink && !isEmployee && !isPrimerConstructor) {
                const user = getCurrentUser();
                const userId = user?._id;
                const lang = user?.lang || "el";
                setLocale(lang);
                dispatch(fetchCompanyStatus({company: company.id, userId: userId}));
                dispatch(fetchCategory({type: "product", company: company.id, year: company.year, isActive: "active"}));
                dispatch(fetchAdvancedTypesSales({company: company.id}));
                dispatch(fetchAdvancedTypesBuys({company: company.id}));
                dispatch(fetchAdvancedTypes({company: company.id}));
                dispatch(fetchPrimerMyDataData({company: company.id, year: company.year.toString()}));
                dispatch(fetchEmailSmtp({company: company.id}));
                dispatch(fetchClientsSettings({company: company.id, year: company.year.toString()}));
                dispatch(fetchSuppliersSettings({company: company.id, year: company.year.toString()}));
                dispatch(fetchCompanyInstallations(company.id));
                dispatch(fetchAccountingSettings({company: company.id, initialLoad: true}));
                dispatch(fetchCompanyDetails(company.id));
                dispatch(fetchSalesGeneralSettings({company: company.id, year: company.year.toString(), isActive: "active" }));
                dispatch(fetchBuysGeneralSettings({company: company.id}));
                dispatch(fetchPayrollSettings(company.id));
                dispatch(fetchSyncInvoicesProviderLog(company.id));
                dispatch(fetchUserSettings(userId, permissionsData));
                dispatch(fetchAccountingPaymentTypes(company));
                if (checkPermission("custom-dashboarddata", permissionsData) === true) {
                    dispatch(fetchDashboardData(company.id, company.year, null, null, true));
                }
            }
        }
    }, [company]);

    return (
        <React.Fragment>
            {isEmronCloudTab ? (
                <React.Fragment>
                    {Object.keys(emronCloudTabData).length > 0 ? (
                        <EmronRegisterFile
                            ssKey={emronCloudTabDataSSKey}
                            fileData={emronCloudTabData}
                        />
                    ) : (
                        <span>Γίνεται φόρτωση παρακαλώ περιμένετε...</span>
                    )}
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <OfflineAlert/>
                    <Navbar permissionsData={permissionsData} />
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar permissionsData={permissionsData} />
                        <ViewWrapper permissionsData={permissionsData} />
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default MainWrapper;
